import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=10912b54&scoped=true"
import script from "./Attachment.vue?vue&type=script&lang=js"
export * from "./Attachment.vue?vue&type=script&lang=js"
import style0 from "../../css/newProjectDetail.css?vue&type=style&index=0&id=10912b54&prod&scoped=true&lang=css&external"
import style1 from "./Attachment.vue?vue&type=style&index=1&id=10912b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10912b54",
  null
  
)

export default component.exports